// components/icons/ArrowDownRightIcon.tsx
"use client";

import {SVGProps} from "react";

/** Diagonal arrow pointing down-right (stroke inherits `currentColor`). */
export default function ArrowUpRightIcon({width = 11, height = 12, className, ...props}: SVGProps<SVGSVGElement> & {width?: number; height?: number}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className} /* Tailwind etc. */
      style={{transform: "translate(1px, -2px)"}}
      aria-hidden="true"
      {...props}>
      <path d="M1.70985 4.5H7.7804M7.7804 4.5V10.5705M7.7804 4.5L0.780396 11.5" stroke="currentColor" strokeWidth={1.3} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
